app.controller("MainNavigationController", 
	["$scope", function($scope) {

		$scope.shownNavi = "";

		$scope.OpenNavigation = function(name) {
			$scope.shownNavi = name;
		};

		$scope.CloseNavigation = function(name) {
			if($scope.shownNavi == name) {
				$scope.shownNavi = "";	
			}
		};

		$scope.ToggleMobiNavi = function() {
			var elem = angular.element('.l-placeholder--header');
			var body = angular.element('body');

			if (elem.hasClass('l-placeholder--header-menu-open')) {
				elem.removeClass('l-placeholder--header-menu-open');
				body.removeClass('no-scroll');
			}
			else {
				elem.addClass('l-placeholder--header-menu-open');
				body.addClass('no-scroll');
			}
		};
	}]
);